<template>
    <el-dialog  title="查看货损"  :visible="CKHSflag" width="1100px"  @close="closeDialog" :close-oni-click-modal="false" :close-on-press-escape="false" center>
      <div class="hsBox">
        <div class="addressBox">
          <h4 class="title">
            <span><i class="fa fa-tags iconFont" aria-hidden="true"></i>货损照片</span>
          </h4>
        </div>
        <div class="imgBox" v-if="imgList.length>0">
            <el-image
              v-for="(item,index) in imgList" :src="item.url" :key="index"
              :preview-src-list="getSrcList(index,imgList)">
            </el-image>
        </div>
        <div v-else style="margin-bottom:20px;padding-left:10px">暂无货损协议照片</div>
      </div>
      <div style="margin: 15px auto" class="el-dialog--center">
        <el-button @click="closeDialog" >取消</el-button>
      </div>
  </el-dialog>

</template>

<script>
import { findInStockDbDamageGoods } from '@/api/wms-access'
import DonMessage from '@/utils/message'
export default {
  name: 'huosunshangchuan',

  props: {
    CKHSflag: {
      type: Boolean,
      default: false
    },
    rowData: {
      type: Object,
      default: function () {
        return {}
      }
    }
  },
  data () {
    return {
      imgList: [],
      addLoad: false

    }
  },
  mounted: function () { // 在更新DOM之前 调用此钩子函数 应用：可以获取原始的DOM
    findInStockDbDamageGoods({ instockId: this.rowData.instockId }).then(res => {
      this.imgList = []
      res.forEach(item => {
        this.imgList.push({ status: 'ready', url: item.fileKeyUrl, id: item.imgId })
      })
    })
  },
  methods: {
    // 点击凭证放大
    getSrcList (index, arr) {
      let imgArr = arr.slice(index).concat(arr.slice(0, index))
      let urls = []
      imgArr.forEach(item => {
        urls.push(item.url)
      })
      return urls
    },
    closeDialog () {
      this.$emit('update:CKHSflag', false)
    }
  },
  destroyed () {

  }
}
</script>

<style scoped lang='less'>
.imgBox{
  /deep/.el-image{
    width: 180px;
    height: 130px;
    margin: 6px;
  }
}
.hsBox /deep/ .el-upload--picture-card{
  width: 180px;
  height: 130px;
}
.hsBox /deep/.el-upload-list--picture-card .el-upload-list__item{
    width: 180px;
    height: 130px;

}
</style>
